import { AuthSystem } from 'models/auth-system'
import { Branch } from 'models/branch'
import { Kartomat } from 'models/kartomat'
import { PaginationResponse } from 'models/pagination'
import { Region } from 'models/region'
import { Role } from 'models/role'
import { Status } from 'models/status'
import { ISubvision } from 'models/subvision'
import { ISupervisor } from 'models/supervisor'
import { UnitBranch } from 'models/user'

import api from '../api'

const commonApi = api.injectEndpoints({
  endpoints: build => ({
    getRegions: build.query<Array<Region>, void>({
      query: () => `/web/regions/`,
    }),
    getSupervisors: build.query<
      PaginationResponse<ISupervisor>,
      { limit?: number; region?: Region['id'] } | void
    >({
      query: params => ({
        url: `/web/supervisors/`,
        params: { limit: 1000, ...params },
      }),
    }),
    getStatuses: build.query<Array<Status>, void>({
      query: () => `/web/statuses/`,
    }),
    getKartomats: build.query<Array<Kartomat>, { free_only?: boolean }>({
      query: params => ({
        method: 'GET',
        url: '/web/kartomat/',
        params: params,
        cache: 'no-store',
        keepUnusedDataFor: 0,
      }),
    }),
    getRoles: build.query<Array<Role>, void>({
      query: () => `/web/roles/`,
    }),
    getSystems: build.query<Array<AuthSystem>, void>({
      query: () => `/auth/me/systems/`,
    }),
    getBranches: build.query<Array<Branch>, void>({
      query: () => `/web/branches/`,
    }),
    getSubvisions: build.query<Array<ISubvision>, void>({
      query: () => `/web/units_credit/`,
    }),
    getMainBranches: build.query<Array<UnitBranch>, void>({
      query: () => `/web/main_branch/`,
    }),
    getUnitBranches: build.query<Array<UnitBranch>, void>({
      query: () => `/web/units_branch/`,
    }),
  }),
})

export const {
  useGetSupervisorsQuery,
  useLazyGetSupervisorsQuery,
  useGetRegionsQuery,
  useGetStatusesQuery,
  useGetRolesQuery,
  useGetSystemsQuery,
  useGetBranchesQuery,
  useGetSubvisionsQuery,
  useGetMainBranchesQuery,
  useGetUnitBranchesQuery,
  useGetKartomatsQuery,
} = commonApi
